<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <!-- Template Card Section Start -->
    <h1 class="mb-4">{{ "responsible" | translate }}</h1>
    <app-contact-card
      [contactCards]="STAFF_DETAILS"
      [totalcount] = "staffTotalcount"
      (onPaginateEvent) = "onStaffPaginateEvent($event)"
    ></app-contact-card>
    <!-- Template Card Section End -->
    <br /><br /><br />
    <!-- Yearly Photo Section Start-->
    <h1 class="mb-4">{{ "yearly_Photo" | translate }}</h1>
    <img
      class="img-fluid"
      src="../../../../assets/img/{{ STAFF_DATA.yearPhoto }}"
      alt=""
    />
    <!-- Yearly Photo Section End-->
    <br /><br /><br />
    <!-- Formation Section Start -->
    <h1 class="mb-4">{{ "formation" | translate }}</h1>
    <app-articles-view
      [articles]="formationArticles"
      [itemsPerPage]="formationLimit"
      [totalcount] ="formationTotalcount"
      (onPaginateEvent) = "onFormationPaginateEvent($event)"
    ></app-articles-view>
    <!-- Formation Section End -->
  </div>
</div>
<!-- Page content end -->
